export const LEARNINGPATHID = "LEARNINGPATHID";
export const LEARNINGPATHNAME = "LEARNINGPATHNAME";
export const SAVE_TAGS = "SAVE_TAGS";
